import { styled, Card, Box, Text } from '@ltvco/refresh-lib/theme';

export const SectionCard = styled(Card)(({ theme }) => ({
  borderRadius: 10,
  boxShadow: theme.shadows[5],
  padding: theme.spacing(2),
}));

export const StepHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.25),
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: 0.5,
  color: theme.palette.text.secondary,
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));

export const Bullet = styled(Box)(() => ({
  position: 'relative',
  width: 27,
  height: 30,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const BulletNumber = styled(Text)(({ theme }) => ({
  color: theme.palette.error.main,
  fontWeight: 800,
  fontSize: theme.typography.pxToRem(14),
  zIndex: 1,
}));

export const BulletBackground = styled('img')(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  zIndex: 0,
}));
